import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/not-a-design-system/not-a-design-system/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "not-a-design-system"
    }}>{`Not a Design System`}</h1>
    <p>{`This is not a design system.`}</p>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install not-a-design-system
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      